/* eslint-disable no-unused-vars */
import React from 'react';
/* eslint-enable no-unused-vars */
import getClientRoutes from 'getClientRoutes';
import {useIntl} from 'react-intl';

const getRouteByName = (name) => {
  const {locale} = useIntl();
  return getClientRoutes()[locale][name];
};

export default getRouteByName;
